export default {"src":"/_next/static/media/Logo_Symbol_Light.06e8f847.svg","height":56,"width":56};